import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { AaaCenter, AaaContactType, AaaPhoneType } from 'types/aaa'
import { Label, Paragraph } from 'components/primitives'

type Props = {
  center?: AaaCenter | null
  rap?: string | null
}
export function DispatchCenter({ center, rap }: Props) {
  const { t } = useTranslation()

  if (!center)
    center = {
      name: 'N/A',
      contact: { contactType: AaaContactType.FACILITY, phones: [{ phoneType: AaaPhoneType.BUSINESS, phoneNumber: 'N/A' }] },
    }
  const { name, contact } = center
  return (
    <>
      <Label>{t('labels.dispatchCenter')}</Label>
      <Paragraph spacing="sm">{name}</Paragraph>
      <Label>{t('labels.RAPCaseId')}</Label>
      <Paragraph spacing="sm">{rap}</Paragraph>
      {contact && contact.phones && contact.phones.length > 0 && (
        <>
          <Label>{t('labels.dispatchContact')}</Label>
          <Paragraph spacing="sm">{formatDispatchPhone(contact.phones[0].phoneNumber)}</Paragraph>
        </>
      )}
    </>
  )
}

function formatDispatchPhone(number: string) {
  const areaCode = number.slice(0, 3)
  const sectionOne = number.slice(3, 6)
  const sectionTwo = number.slice(6)
  return '(' + areaCode + ') ' + sectionOne + '-' + sectionTwo
}

export default DispatchCenter
